"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareNumbers = exports.CompatibleCompareNumbersConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
const operators = {
    lessThan: (left, right) => left < right,
    greaterThan: (left, right) => left > right,
    greaterThanOrEqual: (left, right) => left >= right,
    lessThanOrEqual: (left, right) => left <= right,
};
class CompatibleCompareNumbersConfig {
    constructor(config) {
        this.config = config;
        // Private instance properties allow typescript to ensure that an instance of
        // this class is being used.
        this.isCompatible = true;
        this.ensureCompatibility = (loanTape) => {
            const { field, type, value } = this.config;
            (0, common_1.finleyAssert)(type === typeof value, `Invalid type for config value ${value}. Expected ${type}, got ${typeof value}`);
            const invalidRecord = lodash_1.default.find(loanTape, (record) => {
                const fieldValue = (0, utils_1.getFieldValue)({ loanTape: record, field });
                return !lodash_1.default.isNil(fieldValue) && typeof fieldValue !== type;
            });
            (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({ invalidRecord, field, type }));
            (0, common_1.finleyAssert)(this.isCompatible, 'Config must be compatible with loanTape');
        };
        this.operation = config.operation;
    }
}
exports.CompatibleCompareNumbersConfig = CompatibleCompareNumbersConfig;
CompatibleCompareNumbersConfig.create = (config, loanTape) => {
    const obj = new CompatibleCompareNumbersConfig(config);
    obj.ensureCompatibility(loanTape);
    return obj;
};
/*
 * Selects all loanTapes that meet a numerical comparison test
 * example config:
 * {
 *    field: 'gla';
 *    operator: 'lessThan';
 *    value: 50000;
 * }
 *
 */
const compareNumbers = ({ config: { field, value, operation }, }) => (loanTapeRecords) => lodash_1.default.filter(loanTapeRecords, (loanTape) => {
    const fieldValue = (0, utils_1.getFieldValue)({ loanTape, field });
    return lodash_1.default.isNumber(fieldValue) && operators[operation](fieldValue, value);
});
exports.compareNumbers = compareNumbers;
//# sourceMappingURL=compareNumbers.js.map